import { ref, computed } from 'vue'
import cliente from '@/api/services/cliente'

const token = ref(null)
const refreshToken = ref(null)
const accessTokenExpiresAt = ref(null)
const refreshTokenExpiresAt = ref(null)
const userData = ref(null)

export function useSession() {
  function setLogin(data) {
    token.value = data.accessToken
    refreshToken.value = data.refreshToken
    accessTokenExpiresAt.value = data.accessTokenExpiresAt
    refreshTokenExpiresAt.value = data.refreshTokenExpiresAt
    userData.value = data.user

    localStorage.setItem('token', data.accessToken)
    localStorage.setItem('refreshToken', data.refreshToken)
    localStorage.setItem('accessTokenExpiresAt', String(data.accessTokenExpiresAt))
    localStorage.setItem('refreshTokenExpiresAt', String(data.refreshTokenExpiresAt))
    localStorage.setItem('userData', JSON.stringify(data.user))
  }

  async function loginPublic(maxRetries = 3) {
    for (let i = 1; i <= maxRetries; i++) {
      try {
        const response = await cliente.loginPublic()
        if (response.data?.statusCode === 200) {
          setLogin(response.data.data)
          return response.data.data
        }
        console.warn('Login público fallido:', response.data)
        return null
      } catch (err) {
        console.error(`Error login público (intento ${i}):`, err)
        if (i === maxRetries) return null
        await new Promise(res => setTimeout(res, 1000))
      }
    }
    return null
  }

  function isAccessTokenExpired() {
    return !accessTokenExpiresAt.value || Date.now() > accessTokenExpiresAt.value
  }
  function isRefreshTokenExpired() {
    return !refreshTokenExpiresAt.value || Date.now() > refreshTokenExpiresAt.value
  }

  async function refreshAccessTokenIfNeeded() {
    if (!isAccessTokenExpired()) {
      return token.value
    }
    if (isRefreshTokenExpired()) {
      logout()
      return null
    }
    try {
      const response = await cliente.refreshToken(refreshToken.value)
      if (response.data?.statusCode === 200) {
        setLogin(response.data.data)
        return response.data.data.accessToken
      }
      logout()
      return null
    } catch (err) {
      console.error('Error al refrescar token:', err)
      logout()
      return null
    }
  }

  function logout() {
    token.value = null
    refreshToken.value = null
    accessTokenExpiresAt.value = null
    refreshTokenExpiresAt.value = null
    userData.value = null
    localStorage.clear()
  }

  const isLoggedIn = computed(() =>
    !!token.value && userData.value?.mail !== 'public@public.com'
  )
  const isPublicUser = computed(() =>
    userData.value?.mail === 'public@public.com'
  )

  const isHost = computed(() =>
    userData.value?.role?.name === 'HOST'
  )

  const isHostRequest = computed(() =>
    userData.value?.isHostRequested === true
  )


  // Carga inicial
  if (localStorage.getItem('token')) token.value = localStorage.getItem('token')
  if (localStorage.getItem('refreshToken')) refreshToken.value = localStorage.getItem('refreshToken')
  if (localStorage.getItem('accessTokenExpiresAt'))
    accessTokenExpiresAt.value = +localStorage.getItem('accessTokenExpiresAt')
  if (localStorage.getItem('refreshTokenExpiresAt'))
    refreshTokenExpiresAt.value = +localStorage.getItem('refreshTokenExpiresAt')
  if (localStorage.getItem('userData'))
    userData.value = JSON.parse(localStorage.getItem('userData'))

  return {
    token,
    refreshToken,
    accessTokenExpiresAt,
    refreshTokenExpiresAt,
    userData,
    isLoggedIn,
    isPublicUser,
    isHost,
    isHostRequest,
    setLogin,
    loginPublic,
    refreshAccessTokenIfNeeded,
    isAccessTokenExpired,
    isRefreshTokenExpired,
    logout
  }
}
